import React from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';

import { ErrorScreen } from './error-screen';
import { QuizScreen } from './quiz-screen';
import { ReinstallApp } from './error-screen/reinstall-app';

export const MainScreen: React.FunctionComponent = () => (
	<Switch>
		<Route path="/error/reinstall-app">
			<ReinstallApp />
		</Route>
		<Route path="/error">
			<ErrorScreen />
		</Route>
		<Route path="/test">
			<QuizScreen />
		</Route>
		<Redirect to="/error" />
	</Switch>
);
